<template>
	<popup
			@updateClosePopup="onCloseDialog"
			@updateSave="onSave"
			height-head="40px"
			:title="getTitle"
			:is-btn-safe="getPermissionAction"
			is-all-height
	>
		<div class="formDialog driversForm" :class="{ 'onlyViewWrap': getPermissionAction }">
			<div class="formDialogHeader">
				<div
						class="formDialogHeader_card service"
						:class="{ 'onlyView': getPermissionAction }"
				>
					<field
							:classError="$v.name.$error"
							margin="0"
							width="220px"
							label="Driver name"
							placeholder="Enter full name driver"
							@updateInput="onInput($event, 'name')"
							:setInputValue="name"
							is-required
					></field>
					<field
							margin="0"
							width="170px"
							label="Driver type"
							placeholder="Select driver type"
							@updateAutocomplete="onAutocomplete($event, 'driver_type')"
							:autocompleteValue="driver_type"
							:items="driverList"
							:isClearable="false"
							is-autocomplete
					></field>
					<field
							margin="0"
							width="170px"
							label="Truck number"
							placeholder="Enter truck number"
							:setInputValue="truck_number"
							is-readonly
					></field>
					<field
							margin="0"
							width="190px"
							label="Trailer number"
							placeholder="Select trailer number"
							:setInputValue="trailer_number"
							is-readonly
					></field>
					<field
							margin="0"
							width="170px"
							label="Trailer type"
							placeholder="Trailer type"
							:setInputValue="trailer_type"
							is-readonly
					></field>
					<field
							:classError="$v.customer.$error"
							margin="0"
							width="220px"
							label="Customer"
							placeholder="Select customer name"
							@updateAutocomplete="onAutocomplete($event, 'customer')"
							:autocompleteValue="customer"
							:items="customersList"
							:isClearable="false"
							is-required
							is-autocomplete
					></field>
				</div>
			</div>
			<div class="tabBlock">

					<tab-block
							:tab="tab"
							:tab-list="getTabList"
							@updateTab="onTab"
					></tab-block>

					<v-tabs-items v-if="driversItem" v-model="tab" class="tabs-items">
						<v-tab-item>
							<first-tab
									:valid="$v"
									:email="email"
									:phone="phone"
									:phone2="phone2"
									:comment="comment"
									:notes="notes"
									:getPermissionAction="getPermissionAction"
									@updateFirstTab="onFirstTab"
							></first-tab>
						</v-tab-item>
						<v-tab-item v-if="!isCustomers">
							<second-tab
									:valid="$v"
									:driversList="driversItem"
									:services="services"
									:eld_name="eld_name"
									:eld_url="eld_url"
									:eld_login="eld_login"
									:eld_password="eld_password"
									:driverList="driverList"
									:getPermissionAction="getPermissionAction"
									:driver-id="driverId"
									@updateServiceKey="onServiceKey"
									@updateSafetyRate="onSafetyRate"
									@updateSalaryRate="onSalaryRate"
							></second-tab>
						</v-tab-item>
						<v-tab-item>
							<third-tab
									:list-items="contract"
									:driverList="driverList"
									:drivers-filter="filterContract"
									:id="driverId"
									:getPermissionAction="getPermissionAction"
									@updatePreviewAction="onPreview"
									@updateContract="onContract"
							></third-tab>
						</v-tab-item>
						<v-tab-item>
							<fourth-tab
									:files="files"
									:fileType="fileType"
									:getPermissionAction="getPermissionAction"
									@updateData="onFourthTabData"
									@updatePreviewAction="onPreview"
							></fourth-tab>
						</v-tab-item>
						<v-tab-item>
							<sixth-tab :list-items="driversLogs" :logsFilter="driversLogsFilter"></sixth-tab>
						</v-tab-item>
					</v-tabs-items>

			</div>
			<preview-document v-if="previewLink"></preview-document>
		</div>
		<dialog-info
				v-if="driverId && isDialogInfo"
				:title="dialogInfoTitle"
				:text="dialogInfoText"
				@updateApply="onApplyDialogInfo"
				@updateClose="onApplyDialogInfo"
		></dialog-info>
	</popup>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import FirstTab from "@/components/Maintenance/Drivers/DriversForm/FirstTab/FirstTab.vue";
// shared
import TabBlock from "@/shared/TabBlock/TabBlock.vue";
import Popup from "@/shared/Popup/Popup.vue";
// validations
import { email, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
// constants
import { PERMISSIONS } from "@/constants/constants";
// mixins
import previewMixins from "@/mixins/previewMixins";
import DialogInfo from "@/shared/DialogInfo/DialogInfo.vue";
// async components
const FourthTab = () => import("@/components/Maintenance/Drivers/DriversForm/FourthTab/FourthTab.vue");
const SecondTab = () => import("@/components/Maintenance/Drivers/DriversForm/SecondTab/SecondTab.vue");
const ThirdTab = () => import("@/components/Maintenance/Drivers/DriversForm/ThirdTab/ThirdTab.vue");
const SixthTab = () => import("@/components/Maintenance/Drivers/DriversForm/SixthTab/SixthTab.vue");

export default {
	name: "DriversForm",
	mixins: [ validationMixin, previewMixins ],
	components: {
		DialogInfo,
		SixthTab,
		Popup,
		TabBlock,
		FirstTab,
		SecondTab,
		ThirdTab,
		FourthTab
	},
	props: {
		typeForm: String,
		item: Object,
		driverId: Number,
		isPage: Boolean,
	},
	computed: {
		...mapGetters([
			"driversList",
			"contract",
			"filterContract",
			"isCustomers",
			"permissions",
			"driversItem",
			"driversLogs",
			"driversLogsFilter",
		]),
		getTitle() {
			return this.driverId ? 'Edit driver' : 'Add driver';
		},
		getPermissionAction() {
			if ((this.permissions[PERMISSIONS.CREATE] && !this.driverId) || this.permissions[PERMISSIONS.EDIT])
				return false;
			return this.permissions[PERMISSIONS.VIEW];
		},
		getTypeForm: {
			get() {
				return this.typeFormDriver;
			},
			set(value) {
				this.typeFormDriver = value;
			},
		},
		getTabList() {
			const {
				name,
				email,
				services,
			} = this.$v;

			const values = [
				{
					text: "General info",
					error: name.$error || email.$error,
				},
				{
					text: "Services",
					error:
					services.$error,
				},
				{
					text: "Contracts",
					error: false,
				},
				{
					text: "Files",
					error: false,
				},
			];

			if (this.isCustomers) {
				values.splice(1, 1);
			}

			if (!this.driverId) {
				return values;
			}

			return [ ...values, { text: "Logs", error: false } ];
		},
	},

	data: () => ({
		isDialogInfo: false,
		dialogInfoTitle: "",
		dialogInfoText: "",
		name: "",
		email: "",
		phone: "",
		phone2: "",
		comment: "",
		notes: "",
		truck: "",
		truck_number: "",
		trailer_number: "",
		trailer_type: "",
		customer: null,
		driver_type: null,
		trailer: null,
		driverList: [],
		fileType: [],
		tab: null,
		link: null,
		eld_name: "",
		eld_url: "",
		eld_login: "",
		eld_password: "",
		customersList: [],
		files: [],
		services: {
			safety: {
				status: false,
				customer_status: false,
				driver_rate: 0,
				customer_rate: 0,
				date_from: new Date().toISOString().substr(0, 10),
				safety_id: null,
				service_date_from: new Date().toISOString().substr(0, 10),
			},
			salary: {
				contract: null,
				status: false,
				customer_status: false,
				customer_rate: 0,
				date_from: new Date().toISOString().substr(0, 10),
				driver_rate: 0,
				salary_id: 1,
				service_date_from: new Date().toISOString().substr(0, 10),
			},
		},
	}),
	validations() {
		const { safety, salary } = this.services;
		return {
			name: { required },
			email: { email },
			services: {
				safety: { driver_rate: safety.status ? { required } : {} },
				salary: { driver_rate: salary.status ? { required } : {} },
			},
			customer: { required },
		};
	},
	methods: {
		...mapActions([
			"getDriversItem",
			"onClearDriversList",
			"getDriverDeleteFiles",
			"onDriverDeleteFiles",
			"getContractDelete",
			"setAlert",
			"onDriversSave",
			"getFilterLogs",
			"getCustomerInfoForDriver",
		]),
		onApplyDialogInfo() {
			this.isDialogInfo = false;
		},
		onCloseDialog(isRefresh) {
			this.$emit('updateClose', isRefresh);
		},
		async onTab(value) {
			this.tab = value;
		},
		onContract(idx) {
			this.contract.splice(idx, 1);
		},
		onFourthTabData(files) {
			this.files = files;
		},
		onInput({ value }, key) {
			this[key] = value;
			this.$v[key].$touch();
		},
		async onAutocomplete({ value }, key) {
			// ✅ защита от null
			if (!value) {
				this[key] = null;
				return;
			}

			this[key] = value;

			if (key !== 'customer') return;

			const customerId = value?.id;
			if (!customerId) return;

			// ✅ получаем ответ прямо отсюда
			const res = await this.getCustomerInfoForDriver(customerId);

			const customerRate = res?.customers?.safety_rate_driver;
			const currentRate = this.services?.safety?.driver_rate;

			// ✅ если рейт не пришел — ничего не делаем
			if (customerRate === undefined || customerRate === null) return;

			if (Number(customerRate) !== Number(currentRate)) {

				// ✅ подменить rate
				this.services.safety.driver_rate = customerRate;

				// показать диалог
				if (this.driverId) {
					this.isDialogInfo = true;
					this.dialogInfoTitle = "Attention";
					this.dialogInfoText =
							`Customer safety rate (${ customerRate }) is different from current driver rate (${ currentRate }).<br/><b>Rate has been updated.</b>`;

				}

				// (опционально) чтобы валидация/компоненты обновились гарантированно
				this.$nextTick(() => {
					if (this.$v?.services?.safety?.driver_rate) {
						this.$v.services.safety.driver_rate.$touch();
					}
				});
			} else {
				// если одинаково — можно закрыть диалог (или ничего не делать)
				this.isDialogInfo = false;
				this.dialogInfoTitle = "";
				this.dialogInfoText = "";
			}
		},
		onServiceKey({ status, date, serviceKey }) {
			this.services[serviceKey].status = status;
			this.services[serviceKey].date_from = date;
		},
		onSafetyRate(value, key) {
			if (key === "driver_rate") {
				this.services.safety[key] = value;
			} else {
				this[key] = value;
			}
		},
		onSalaryRate(value, key) {
			this.services.salary[key] = value;
		},
		onClose(isRefresh) {
			this.onClearDriversList();
			this.$emit('updateClose', isRefresh);
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					name,
					email,
					phone,
					phone2,
					comment,
					notes,
					files,
					driver_type,
					customer,
					trailer_type,
					trailer_number,
					truck_number,
					eld_login,
					eld_name,
					eld_password,
					eld_url,
					services,
				} = this.$data;
				const values = {
					name,
					email,
					phone,
					phone2,
					comment,
					notes,
					files,
					type_id: driver_type?.id ?? driver_type,
					customer_id: customer?.id ?? customer,
					trailer_type,
					trailer_number,
					truck_number,
					eld_login,
					eld_name,
					eld_password,
					eld_url,
					services,
				};

				const response = await this.onDriversSave({ values, id: this.driverId });

				if (response.errors) {
					const { name } = response?.errors;
					const message = name
						? "Driver already exist"
						: "The users email has already been taken.";
					this.setAlert({ type: "error", message });
				} else {
					await this.onDriverDeleteFiles();
					this.getDriverDeleteFiles({ isDelete: true });
					this.getContractDelete({ isDelete: true });

					this.setAlert({ type: "success", message: "Saving Successfully" });
					this.onClose(1);
				}
			} else {
				await this.setAlert({ type: "error", message: "Saving error" });
			}
		},
		onFirstTab({ value, key }) {
			this[key] = value;
		},
	},
	async mounted() {
		await this.getDriversItem(this.driverId);
		if (this.driverId) {
			const driver_id = this.driverId;
			await this.getFilterLogs({ driver_id });
		}

		const {
			customers,
			driver_type: driverList,
			driver,
			service,
			files,
			fileType,
		} = this.driversItem;
		const {
			trailer_number,
			name,
			email,
			phone,
			phone2,
			comment,
			notes,
			driver_type,
			truck_number,
			trailer_type,
			customer_id,
			eld_name,
			eld_url,
			eld_login,
			eld_password,
		} = driver || {};

		const driverObj = driverList.find((item) => item.value === driver_type) || null;
		const customerObj = customers.find((item) => item.id === customer_id) || null;

		for (const item in service) {
			const { driver_rate, customer_rate } = service[item];
			service[item]["driver_rate"] = driver_rate ?? customer_rate;
			this.$set(this.services, item.toLowerCase(), { ...service[item] });
		}

		this.customersList = customers;
		this.driver_type = driverObj;
		this.driverList = driverList;
		this.trailer_number = trailer_number;
		this.name = name;
		this.email = email;
		this.phone = phone;
		this.phone2 = phone2;
		this.comment = comment;
		this.notes = notes;
		this.truck_number = truck_number;
		this.trailer_type = trailer_type;
		this.customer = customerObj;
		this.eld_name = eld_name;
		this.eld_url = eld_url;
		this.eld_login = eld_login;
		this.files = files;
		this.eld_password = eld_password;
		this.fileType = fileType;
	},
};
</script>

<style scoped lang="scss">
//@import "driversForm";
@import "@/assets/style/components/formDialog.scss";

</style>
